export default "__VITE_ASSET__sBapHG0Q__"